import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateThemesState from './themes';
import updateImagesState from './images';

const handlers = {
  ...updateThemesState,
  ...updateImagesState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
